module.exports = __webpack_public_path__ + "static/media/search-church.e5a95b4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/search-church.svg
// module id = 529
// module chunks = 0